import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { BookingWindowRuleValidation } from 'uplisting-frontend/validations';

export default class BookingWindowRuleRepositoryService extends BaseRepositoryService<
  ModelRegistry['booking-window-rule']
> {
  recordName = 'booking-window-rule';
  implementMethods = ['buildChangeset', 'findAll', 'unloadAll'];

  validation = BookingWindowRuleValidation;
}

declare module '@ember/service' {
  interface Registry {
    'repositories/booking-window-rule': BookingWindowRuleRepositoryService;
  }
}
